export const withWhomDefault = [
  'Jag',
  'Med familj',
  'Med andra',
];
